
import { createContext, useContext, useState, useEffect } from "react";

const PortalContext = createContext();

export const PortalProvider = ({ children }) => {
    const [portal, setPortal] = useState("admin"); // default to admin
    const [adminType, setAdminType] = useState();

    useEffect(() => {
        const stored = localStorage.getItem("portal");
        if (stored) setPortal(stored);
    }, []);

    const switchPortal = (newPortal) => {
        setPortal(newPortal);
        localStorage.setItem("portal", newPortal);
    };

    useEffect(() => {
        const switchtype = localStorage.getItem("portal");
        if (switchtype) {
            setAdminType(switchtype);
        }
    }, []);

    return (
        <PortalContext.Provider value={{ portal, switchPortal }}>
            {children}
        </PortalContext.Provider>
    );
};

export const usePortal = () => useContext(PortalContext);
